import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomLayout from "../Layout/CustomLayout";
import { Typography, Image } from "antd";
import ReceptionistSideMenu from "../Layout/CustomLayout/ReceptionistSideMenu";
import AllPatient from "./AllPatient/AllPatient";
import textStyles from "../../styles/Custom/Typography.module.css";
import Inpatients from "./Inpatients/Inpatients";
import Appointments from "./Appointments/Appointments";
import { getPatientListApi } from "../../services/receptionist.services";
import { getCookie } from "../../helpers/localStorage";
import { FacilityID } from "../../constants/defaultKeys";
import { UserContext } from "../../context/UserContext";
import Investigations from "./Investigations/Investigations";
import useQuery from "../../hooks/useQuery";
import {
  updateUrlSearchParams,
  parsePageParam,
  parseSearchParam,
} from "../../helpers/urlFilters";
import PatientsIP from "../PatientsIP/PatientsIP";
import Billing from "./Billing/Billing";
import BillingPage from "./Billing/BillingPage";
import PartnerOnboarding from "./PartnerOnboarding/PartnerOnboarding";
import Outpatients from "./Outpatients/Outpatients";
import Services from "../Dashboard/Services/Services";
import Users from "../Dashboard/Users/Users";
import ReceptionistDashboard from "./Dashboard/ReceptionistDashboard";
import ReceptionistPageTitle from "./ReceptionistPageTitle";

const Receptionist = () => {
  const query = useParams();
  const params = useQuery();
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useContext(UserContext);
  const [patientData, setPatientData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const page = parsePageParam(params);
  const searchQuery = parseSearchParam(params);

  const setPage = (nextPage) => {
    updateUrlSearchParams(navigate, { page: nextPage });
  };

  const setSearchQuery = (value) => {
    updateUrlSearchParams(navigate, { search: value || null, page: 1 });
  };

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };
  useEffect(() => {
    if (query?.tab === "home" && !params?.type) {
      setLoading(true);
      let queryParams = {
        page: page,
        limit: 20,
        facility_id: Number(getCookie(FacilityID)) || userDetails?.currFacility,
      };
      if (searchQuery) {
        queryParams.search = searchQuery;
        queryParams.page = 1;
      }
      const queryString = new URLSearchParams(queryParams);
      getPatientListApi(queryString)
        .then((res) => {
          setLoading(false);
          setPatientData(res?.data);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [
    Number(getCookie(FacilityID)) || userDetails?.currFacility,
    refresh,
    searchQuery,
    page,
    query?.tab,
    location?.search,
  ]);

  const renderContent = () => {
    switch (query?.tab) {
      case "dashboard":
        return <ReceptionistDashboard refresh={refreshPage} />;
      case "home":
        return params?.patient ? (
          <>
            <PatientsIP />
          </>
        ) : (
          <AllPatient
            data={patientData}
            refresh={refreshPage}
            searchQuery={searchQuery}
            page={page}
            setPage={setPage}
            setSearchQuery={setSearchQuery}
            loading={loading}
          />
        );
      // case "in-patients":
      //   return <Inpatients refresh={refreshPage} />;
      case "appointments":
        return <Appointments />;
      case "investigation":
        return <Investigations />;
      case "partner_onboarding":
        return <PartnerOnboarding />;
        case "services":
        return <Services />;
        case "users":
        return <Users />;



      default:
        return query?.tab === "ip" || query?.tab === "bill" ? (
          <PatientsIP />
        ) : params?.patient ? (
          <BillingPage />
        ) : (
          <Billing />
          
        );
    }
  };
  return (
    <>
      {query?.tab === "in-patients" ? (
        <Inpatients refresh={refreshPage} />
  
      ) : query?.tab === "out-patients" ? (
        <Outpatients refresh={refreshPage} />
  
      ) : query?.tab === "dashboard" ? (
        <CustomLayout
          layoutClassName="reception-layout"
          sideContent={<ReceptionistSideMenu refresh={refreshPage} />}
          header={
            <Typography className={textStyles.h6}>
              Dashboard
            </Typography>
          }
        >
          {renderContent()}
        </CustomLayout>
      ) : params?.patient ? (
        <CustomLayout patientEmrMode>{renderContent()}</CustomLayout>
  
      ) : query?.tab === "services" ? (
        <Services />
      ) : query?.tab === "users" ? (
         <Users />
  
      ) : (
        <CustomLayout
          layoutClassName="reception-layout"
          sideContent={<ReceptionistSideMenu refresh={refreshPage} />}
          header={
            query?.tab === "home" ? (
              <ReceptionistPageTitle count={patientData?.total_count}>
                All Patients
              </ReceptionistPageTitle>
            ) : (
              <Typography className={textStyles.h6}>
                {query?.tab === "in-patients"
                  ? "In Patients"
                  : query?.tab === "billing"
                  ? "Billing"
                  : query?.tab === "appointments"
                  ? "Appointments"
                  : query?.tab === "partner_onboarding"
                  ? "Partner Onboarding"
                  : query?.tab === "investigation" && "Investigations"}
              </Typography>
            )
          }
        >
          {renderContent()}
        </CustomLayout>
      )}
    </>
  );

};

export default Receptionist;
